import { useState, useEffect, useRef } from 'react'
import Swal from 'sweetalert2'
import Breadcrumb from '../../components/breadcrumb/index'
import Logo from '../../assets/photo/admin.jpg'
import {useNavigate,useParams} from 'react-router-dom'

export default function Edit_Faq() {
    const title = "Edit Faq"
    const {id} =useParams() //ei number diye data update korte hobe
    const navigate=useNavigate()
    const[rerendarApi,setRerendarApi]=useState(false)
        const[data,setData]=useState('')
    const brad = [
        {
            name: "home",
        },
        {
            name: title,
        }
    ]


    {/* data receve from store */ }
    useEffect(() => {
        // call api
        setData('set your data')
        console.log("render from invoice")
    }, [rerendarApi])


    const edit_faq=()=>{
        
        Swal.fire({
            icon:'warning',
            title: 'You wont be able to revert this!',       
            showCancelButton: true,
            confirmButtonText: 'Yes',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            setRerendarApi(!rerendarApi)
            if (result.isConfirmed) {
              Swal.fire('Saved!. id:', '', 'success')
            } else if (result.isDenied) {
              Swal.fire('Changes are not saved', '', 'info')
            }
          })
    }

    return (
        <>

            <div  className="container-fluid">
                <Breadcrumb title={title} brad={brad} />

                <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
                    <div className="card-header d-flex justify-content-between border-bottom pb-1">
                        <div className="">{title} </div>
                        <div className="btn btn-info btn-sm" onClick={()=>navigate(-1)}>Back</div>

                    </div>
                    <div className="card-body">
                        <div  className="row ">
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>select brand</ b></label>
                                <select className="form-control">
                                    <option value="">onhost</option>
                                    <option value="">onhost2</option>

                                </select>
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>English Title</ b></label>
                                <input type="text" placeholder="English Title" className="form-control" />
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>Bangla Title</ b></label>
                                <input type="text" placeholder="Bangla Title" className="form-control" />
                            </div>
                            
                            <div  className="col-12 mt-3">
                                <label for="brand"><b>English content</ b></label>
                                <textarea type="text" placeholder="English content" rows="5" className="form-control" ></textarea>
                            </div>
                            <div  className="col-12 mt-3">
                                <label for="brand"><b>Bangla Content</ b></label>
                                <textarea type="text" placeholder="Bangla Content" rows="5" className="form-control" ></textarea>
                            </div>
                            <div  className="col-md-6 mt-3">
                                <label for="brand"><b>Status</ b></label>
                                <select className="form-control">
                                    <option value="">Active</option>
                                    <option value="">Pending</option>

                                </select>
                            </div>
                        </div>
                        <button onclick={edit_faq} className="btn btn-primary btn-sm mt-4">Edit Faq</button>
                    </div>
                </div>
            </div>

        </>
    )
}